import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { StartupService } from "@core/services/startup.service";
import { MetacomStatusType } from "@shared/enums";
import { delay, take } from "rxjs";

@Component({
  selector: "app-startup",
  standalone: true,
  imports: [],
  templateUrl: "./startup.component.html",
  styleUrl: "./startup.component.scss",
})
export class StartupComponent implements OnInit {
  constructor(private router: Router, private startupService: StartupService) {}

  ngOnInit(): void {
    this.startupService
      .fetchQueryParamtersAndUpdateStates()
      .pipe(take(1), delay(1500))
      .subscribe((metacomType) => {
        if (metacomType === MetacomStatusType.loginOpen) {
          this.router.navigate(["/landing"]);
        } else if (metacomType === MetacomStatusType.loginWalled) {
          this.router.navigate(["/data-limit"]);
        } else {
          this.router.navigate(["/404"]);
        }
      });
  }
}
